module.exports = __webpack_public_path__ + "static/avina-projeto_r2-0dc7136d55d75bceca54a6c5391c7631.jpg";